export default __webpack_public_path__ + "static/media/T_64_desktop.cfaccf93.jpg";